// @avantia common-code
import { convertCaseOfModelKeys, ensureDefined, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { HpError } from '@avantia/logging-and-errors';

let allHashKeys: string[] | undefined;

export function getAllHashKeys<HashMapT>(): (keyof HashMapT)[] {
  if (allHashKeys) {
    return allHashKeys as any;
  }

  throw new HpError("The 'allHashKeys' value has not been set. Use the 'registerAllHashKeys' function to do so.");
}

export function registerAllHashKeys<HashMapT>(allKeys: (keyof HashMapT)[]): void {
  allHashKeys = ensureDefined(allKeys, 'allKeys') as string[];
}

export function getHashRecord<RecordT extends Record<string, any>>(hash: string, keys: (keyof RecordT)[]): RecordT {
  const map = getHashMap(hash);
  return convertCaseOfModelKeys(map, keys as string[]) as RecordT;
}

/**
 * Generally, use of getHashRecord(...) is preferred (which is strongly typed).
 * @param {string} hash the string to create a map from.
 */
export function getHashMap(hash: string): SMap<string> {
  const hashMap: SMap<string> = {};
  if (hash) {
    lodash
      .trimStart(hash, '#')
      .replace(/,/g, '&')
      .split('&')
      .map((v) => v.split('='))
      .forEach((v) => {
        const [key, val] = v;
        hashMap[key] = decodeURIComponent(val);
      });
  }

  return hashMap;
}
